export const EXPLORE_PRESET = 'Explore';
